import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Home } from './pages/Home';
import { Register } from './pages/Register';
import { RegisterSuccess } from './pages/RegisterSuccess';
import { Login } from './pages/Login';
import { PasswordReset } from './pages/PasswordReset';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { Applications } from './pages/Applications';
import { ApplicationLayout } from './pages/ApplicationLayout';
import { ApplicationOverview } from './pages/ApplicationOverview';
import { ApplicationAnalytics } from './pages/ApplicationAnalytics';
import { Subscriptions } from './pages/Subscriptions';
import { SubscriptionDetails } from './pages/SubscriptionDetails';
import { WalletPage } from './pages/Wallet';
import { AnalyticsPage } from './pages/Analytics';
import { Support } from './pages/Support';
import { TeamManagement } from './pages/TeamManagement';
import { PublicStatus } from './pages/PublicStatus';
import { CatalogRedirect, SubscriptionsRedirect } from './components/SmartRedirect';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <EnvironmentProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/register" element={<Register />} />
          <Route path="/register-success" element={<RegisterSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />

          {/* Protected routes with layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/status" element={<PublicStatus />} />

            <Route
              path="/applications"
              element={
                <ProtectedRoute>
                  <Applications />
                </ProtectedRoute>
              }
            />

            <Route
              path="/catalog"
              element={
                <ProtectedRoute>
                  <CatalogRedirect />
                </ProtectedRoute>
              }
            />

            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute>
                  <SubscriptionsRedirect />
                </ProtectedRoute>
              }
            />

            <Route
              path="/applications/:id"
              element={
                <ProtectedRoute>
                  <ApplicationLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<ApplicationOverview />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="products/:productId" element={<ProductDetail />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="subscriptions/new" element={<Subscriptions />} />
              <Route path="subscriptions/:subId" element={<SubscriptionDetails />} />
              <Route path="analytics" element={<ApplicationAnalytics />} />
            </Route>

            <Route
              path="/wallet"
              element={
                <ProtectedRoute>
                  <WalletPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <AnalyticsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/support"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />

            <Route
              path="/team"
              element={
                <ProtectedRoute>
                  <TeamManagement />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </EnvironmentProvider>
    </BrowserRouter>
  );
};

export default App;
